import polish from "common-frontend/src/utils/languages/pl.json";
import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const resources = {
  // en: {
  //   translation: english,
  // },
  pl: {
    translation: polish,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  // .use(LanguageDetector)
  .init({
    resources,
    lng: "pl",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
